module.exports = __webpack_public_path__ + "static/Steps-Mono-Thin-02471c09fd46e64a6e19fdb2c7513dc4.svg";